module.exports = __webpack_public_path__ + "media/img/specialize/item8-a2465721cf027ce6bab157296f0e7ed9.svg";